// Also blocks Hebrew, Arabic, Korean, Japanese, ...
export const latinRegex = /^([,./\dA-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF\s-]+)$/
